export const pelangganFormData = (dropdownPelangganJenis) => {
  return [
    {
      id: "id_pelanggan_jenis",
      label: "Pilih Jenis Pelanggan",
      fields: [
        {
          type: "option",
          options: dropdownPelangganJenis,
        },
      ],
    },
    {
      id: "nama_pelanggan",
      label: "Nama Pelanggan",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nama Pelanggan",
        },
      ],
    },
    {
      id: "no_hp_pelanggan",
      label: "Nomor HP Pelanggan",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nomor HP Pelanggan",
        },
      ],
    },
  ];
};
